export enum WidgetUIType {
  UpcomingTeams,
  RecentlyAccepted,
  RecentFormResponses,
  InProgressCredentialApplications,
  LatestFormSubmissions
}
